module.exports = __webpack_public_path__ + "img/btn_heng.058a43c7.png";